import { Chip, SxProps, Theme, Tooltip } from '@mui/material';
import { ActionStatus } from '../../../../../shared/services/report-action/report-action.model';

export const ACTION_STATUS_LABELS: Record<ActionStatus, string> = {
  blocked: 'Blocked',
  waiting_external: 'Waiting on third party',
  not_applicable: 'Not applicable',
};

const chipColor = (status: ActionStatus): 'warning' | 'default' => {
  return status === 'not_applicable' ? 'default' : 'warning';
};

type Props = {
  status: ActionStatus;
  reason?: string | null;
  sx?: SxProps<Theme>;
};

// The workflow status a person put on an action ("I can't provide this", waiting on a third
// party, not applicable). The reason travels as the tooltip so an admin sees why at a glance.
export const ActionStatusChip = ({ status, reason, sx }: Props) => {
  const chip = (
    <Chip
      label={ACTION_STATUS_LABELS[status]}
      size='small'
      color={chipColor(status)}
      variant='outlined'
      sx={sx}
    />
  );
  return reason ? <Tooltip title={reason} placement='top'>{chip}</Tooltip> : chip;
};
